import { Api } from "@/plugins/api"

export const affichageRetourALaPratique = (sasId) => {
  return Api.get(`/sas-adresses/affichage-retour-pratique/${sasId}`)
}

export const affichageRetourALaPratiqueAjoutLieuExercice = (token) => {
  return Api.get(`/demande-ajout-lieu-exercice/affichage-retour-pratique?token=${token}`)
}